<template>
    <div class="cardItem">
        <div class="cardNumbers">
          <span v-for="(value, index) in panPositions">
            <label class="panPlaceholder" v-if="printX(index)">X </label>
            <div v-else class="cardField">
                <span :class="{ 'has-error' : $v.panDigitsModel.$each[value].Digit.$error }">
                    <span class="form__label__card" :class="{ 'error_input' : $v.panDigitsModel.$each[value].Digit.$error }">
                        <input class="form__input__card"
                              :id="name + value"
                              :name="name + value"
                              :ref="name + value"
                              :required="required"
                              :placeholder="placeholder"
                              :validators="validators"
                              v-model=panDigitsModel[value].Digit
                              maxlength="1"
                              @focus="currentInputIndex = value"
                              @keydown="touchField($v.panDigitsModel.$each[value].Digit)"/>
                    </span>
                </span>
            </div>
            <span v-if="(index+1) % 4 == 0">&nbsp;&nbsp;</span>
            </span>
        </div>
        <span>
            <label v-if="required && anyNotFilled() && !anyNotDigit()" class="form__label-title error">{{ $t('validations.required') }}</label>
            <label v-if="anyNotDigit()" class="form__label-title error">{{ $t('validations.notADigit') }}</label>
            <label v-if="regexValidation" class="form__label-title error">{{ translate(findValidator(this.validators, 'regExp').localizedErrorMessage) }}</label>
        </span>
    </div>
</template>
<script>
import OnboardInputMixin from '@/mixins/OnboardInputMixin';

function isDigitNotEmpty(value) {
  return value !== '' && !Number.isNaN(Number(value));
}

export default {
  name: 'OnboardCardPanInput',
  mixins: [OnboardInputMixin],
  created() {
    this.panDigitsModel = this.panDigits.map((item) => { return { Position: item.Position, Digit: '' }; });
    let counter = 0;
    for (let index = 1; index <= this.panPositions.length; index += 1) {
      if (this.panDigitsModel.some((item) => { return item.Position === index; })) {
        this.panPositions[index - 1] = counter;
        counter += 1;
      }
    }
  },
  props: {
    panDigits: { type: Array },
  },
  data() {
    return {
      panDigitsModel: { type: Array },
      currentInputIndex: 0,
      panPositions: new Array(16),
    };
  },
  watch: {
    panDigitsModel: {
      immediate: true,
      deep: true,
      handler() {
        this.focusOnNextPanInput(this.currentInputIndex);
        this.containsError(this.$v.panDigitsModel);
      },
    },
  },
  methods: {
    printX(index) {
      const item = this.panDigits.find((element) => { return element.Position === (index + 1); });
      return !item;
    },
    touchField(value) {
      value.$touch();
    },
    allDirty() {
      for (let index = 0; index < this.panDigits.length; index += 1) {
        if (this.$v.panDigitsModel.$each[index] !== undefined
        && !this.$v.panDigitsModel.$each[index].Digit.$dirty) {
          return false;
        }
      }
      return true;
    },
    anyNotFilled() {
      for (let index = 0; index < this.panDigits.length; index += 1) {
        if (this.$v.panDigitsModel.$each[index] !== undefined
        && this.$v.panDigitsModel.$each[index].Digit.$dirty
        && !this.$v.panDigitsModel.$each[index].Digit.required) {
          return true;
        }
      }
      return false;
    },
    anyNotDigit() {
      for (let index = 0; index < this.panDigits.length; index += 1) {
        if (this.$v.panDigitsModel.$each[index] !== undefined
        && this.$v.panDigitsModel.$each[index].Digit.$dirty
        && !this.$v.panDigitsModel.$each[index].Digit.numeric) {
          return true;
        }
      }
      return false;
    },
    focusOnNextPanInput(index) {
      if (index !== 3 && this.$v.panDigitsModel.$anyDirty && isDigitNotEmpty(this.panDigitsModel[index].Digit)) {
        if (isDigitNotEmpty(this.panDigitsModel[index + 1].Digit)) {
          this.focusOnNextPanInput(index + 1);
        } else {
          this.$refs[this.$props.name + (index + 1)][0].focus();
        }
      }
    },
  },
};
</script>
